  /*
         ___  ___  _    ___   _  _ 
    /\  |   \/ _ \| |  / _ \ | \/ |
   /  \ |  _/ (_) | |_  (_)  |    | _
  / /\ \|_|  \___/|___|\___/ |_\/_|(_)


      Name: Custom scripts
   Version: 1.0.0
    Author: Julio Maturrano
   Website: http://apolomultimedia.us

  */


(function($){
  $(document).ready(function(){

/*

Here begin.

----------------------------------------------- */
    
    /*
    **GENERAL**
    =============================================== */
    setTimeout(function(){
      custom_product_options();
    }, 500);
    
    
  });
  
  
  function custom_product_options(){
    if( $('.product-template').length && $('.single-option-selector').length ){
      $('.single-option-selector').filter(function(){
        return !$(this).closest('[data-wo-purchase]').length;
      }).each(function(){
        var $option = $(this).parent().find('label');
        var option 	= $option.text();
        
        if($(window).width() > 768){
          $option.hide();
        }
        $(this).prepend('<option value="">Select '+option+'</option>');
        $(this).val('');
      });
    }
  }
  
})(jQuery);